
import { HistoryQueries } from '@empathyco/x-components/history-queries'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'XHistoryQueries',
  components: {
    HistoryQueries,
  },
  props: {
    maxItemsToRender: {
      type: Number,
      default: 5,
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-x-history-queries',
    }
  },
})
